import React from 'react';
import RoutedTabs from 'src/components/routed-tabs';
import {Switch, Route, Redirect} from 'react-router-dom';
import CreateUGSSStudent from 'src/views/admin/CreateUGSSStudent';
import UGSSColumnMappings from 'src/views/admin/UGSSColumnMappings';

const tabs = [
  {label: 'Create Student', path: '/create-student'},
  {label: 'Column Mappings', path: '/column-mappings'},
];

const UGSSTools = () => (
  <div>
    <RoutedTabs tabs={tabs} className="text-center" />
    <Switch>
      <Route path="/admin/tools/ugss/create-student" component={CreateUGSSStudent} />
      <Route path="/admin/tools/ugss/column-mappings" component={UGSSColumnMappings} />
      <Redirect path="*" to="/admin/tools/ugss/create-student" />
    </Switch>
  </div>
);

export default UGSSTools;
